<div class="container">
  <div class="title">
    <h1>Certificate Gallery</h1>
  </div>
<div id="carouselExampleDark"  class="carousel carousel-dark slide" data-bs-ride="carousel" data-aos="fade-left">
    <div class="carousel-indicators">
      <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
      <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
      <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
      <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="3" aria-label="Slide 4"></button>
      <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="4" aria-label="Slide 5"></button>
    </div>
    
    <div class="carousel-inner">
        
      <div class="carousel-item active" data-bs-interval="10000">
        <img   src="../../assets/Certtt.png" class="d-block w-100 " alt="...">
        <div class="carousel-caption d-none d-md-block">
          <h5>slide 1</h5>
         
        </div>
      </div>
      <div class="carousel-item" data-bs-interval="2000">
        <img  src="../../assets/JS.JPG" class="d-block w-100 " alt="...">
        <div class="carousel-caption d-none d-md-block">
          <h5> slide 2 </h5>
          
        </div>
      </div>
      <div class="carousel-item" data-bs-interval="2000">
        <img  src="../../assets/Responsive.JPG" class="d-block w-100 " alt="...">
        <div class="carousel-caption d-none d-md-block">
          <h5>slide 3</h5>
         
        </div>
      </div>
      <div class="carousel-item" data-bs-interval="2000">
        <img  src="../../assets/ScrumStudy.JPG" class="d-block w-100 " alt="...">
        <div class="carousel-caption d-none d-md-block">
          <h5>slide 4</h5>
        </div>
      </div>
      <div class="carousel-item">
        <img   src="../../assets/Digital.JPG" class="d-block w-100 " alt="...">
        <div class="carousel-caption d-none d-md-block">
          <h5> slide 5 </h5>
        </div>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>

  